module.exports = __webpack_public_path__ + "img/想要了解成都.240db1ad.png";